import { render, staticRenderFns } from "./WhoIAm.vue?vue&type=template&id=9f771812&lang=pug&"
import script from "./WhoIAm.vue?vue&type=script&lang=js&"
export * from "./WhoIAm.vue?vue&type=script&lang=js&"
import style0 from "./WhoIAm.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports